import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ErrorDetails, SurrenderReportPagesResponseDTO } from '../../interfaces/apiInterfaces.d';

export class GetSurrenderReportCommand extends IRequestCommand<
  IGetSurrenderReportCommandResponse,
  ErrorDetails,
  IGetSurrenderReportCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/travels/surrendersReports/paginated?';

  public override setParameters(parameters: IGetSurrenderReportCommandParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId);
    this._commandUrl += parameters.page != null ? `&page=${parameters.page}` : '';
    this._commandUrl += parameters.size != null ? `&size=${parameters.size}` : '';
    this._commandUrl += parameters.column && parameters.column.length > 0 ? `&column=${parameters.column}` : '';
    this._commandUrl += parameters.sort && parameters.sort.length > 0 ? `&sort=${parameters.sort}` : '';
    this._commandUrl += parameters.driverId ? `&driverId=${parameters.driverId}` : '';
    this._commandUrl += parameters.ownerId ? `&ownerId=${parameters.ownerId}` : '';
    this._commandUrl += parameters.domain && parameters.domain.length > 0 ? `&domain=${parameters.domain}` : '';
    this._commandUrl += parameters.from && parameters.from.length > 0 ? `&from=${parameters.from}` : '';
    this._commandUrl += parameters.to && parameters.to.length > 0 ? `&to=${parameters.to}` : '';
  }
}

export interface IGetSurrenderReportCommandParameters extends ICommandParameters {
  carrierId: string;
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  driverId?: string;
  ownerId?: string;
  domain?: string;
  from?: string;
  to?: string;
}

export interface IGetSurrenderReportCommandResponse
  extends SurrenderReportPagesResponseDTO, ICommandResponse {}
